import React from 'react';
import { FilterSelect } from '../../../shared/table/FilterSelect';

export const DashboardMainDrawer = ({
    isOpen,
    onClose,
    days,
    quickRangeOptions,
    onDaysChange,
    dateFrom,
    dateTo,
    onDateFromChange,
    onDateToChange,
    customerId,
    customerOptions,
    onCustomerChange,
    projectId,
    projectOptions,
    onProjectChange,
    onApply,
    onClear,
    isLoading,
}) => {
    React.useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handleEscape = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="ticket-filters-drawer-overlay" onClick={onClose}>
            <aside className="ticket-filters-drawer" onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-label="Filtros de dashboard">
                <div className="ticket-filters-drawer__header">
                    <div>
                        <h6 className="mb-0 fw-bold">Filtros de dashboard</h6>
                    </div>
                    <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
                        <i className="feather-x" />
                    </button>
                </div>

                <div className="ticket-filters-drawer__body">
                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Rango rápido</label>
                        <FilterSelect
                            value={days}
                            options={quickRangeOptions}
                            onChange={(nextValue) => onDaysChange(Number(nextValue || 30))}
                            placeholder="Rango"
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Desde</label>
                        <div className="dashboard-date-input">
                            <input
                                type="date"
                                className="form-control form-control-sm dashboard-date-input__control"
                                value={dateFrom}
                                onChange={(event) => onDateFromChange(event.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Hasta</label>
                        <div className="dashboard-date-input">
                            <input
                                type="date"
                                className="form-control form-control-sm dashboard-date-input__control"
                                value={dateTo}
                                onChange={(event) => onDateToChange(event.target.value)}
                                disabled={isLoading}
                            />
                        </div>
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Cliente</label>
                        <FilterSelect
                            value={customerId}
                            options={customerOptions}
                            onChange={(nextValue) => onCustomerChange(nextValue || '')}
                            placeholder="Todos"
                            searchable
                            searchPlaceholder="Buscar cliente..."
                        />
                    </div>

                    <div className="ticket-filters-drawer__field">
                        <label className="form-label form-label-sm mb-1 fw-semibold">Proyecto</label>
                        <FilterSelect
                            value={projectId}
                            options={projectOptions}
                            onChange={(nextValue) => onProjectChange(nextValue || '')}
                            placeholder="Todos"
                            searchable
                            searchPlaceholder="Buscar proyecto..."
                        />
                    </div>
                </div>

                <div className="ticket-filters-drawer__footer d-flex gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-secondary w-100"
                        onClick={onClear}
                        disabled={isLoading}
                    >
                        Limpiar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={() => {
                            onApply();
                            onClose();
                        }}
                        disabled={isLoading}
                    >
                        Aplicar
                    </button>
                </div>
            </aside>
        </div>
    );
};
